module.exports = __webpack_public_path__ + "img/wild4.b552c022.png";